import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js'

// Per-variant carousel: show the carousel matching the active Size value,
// hide the other. No-op for products without a Size picker — caller falls back
// to the legacy single-carousel slide behavior when this returns false.
const updateSizeCarousel = ($form) => {
    const $product = $form.closest('#product-page')
    if (!$product) return false

    const $sizeCarousels = $product.querySelectorAll('[data-size-carousel]')
    if ($sizeCarousels.length === 0) return false

    const $sizeInput = $form.querySelector('.custom-size-picker-input:checked')
    const sizeKey = $sizeInput && $sizeInput.value === 'XL' ? 'xl' : 'original'

    $sizeCarousels.forEach(($el) => {
        $el.classList.toggle('d-none', $el.dataset.sizeCarousel !== sizeKey)
    })

    return true
}

// Mirror of the discount math in snippets/product-sale-price-pdp.liquid.
// When a sitewide sale event is configured and the product isn't excluded,
// returns the discounted price plus an effective compare-at to drive the
// strikethrough. Also returns the subscription price (Recharge selling-plan
// allocation, no sale stacking — matches Liquid intent). Server-side Liquid
// renders the right initial price; this keeps the picker in sync when the
// user toggles variants client-side.
const computeDisplayPrice = (variant) => {
    const sale = window.RAVN_SALE_EVENT
    const isExcluded = sale && Array.isArray(sale.excludedProductIds)
        && sale.excludedProductIds.indexOf(variant.product_id) !== -1
    const discountActive = sale && sale.percentageDiscount > 0 && !isExcluded

    const subPrice = (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0)
        ? variant.selling_plan_allocations[0].price
        : null

    if (!discountActive) {
        return {
            price: variant.price,
            compareAt: (variant.compare_at_price && variant.compare_at_price > variant.price)
                ? variant.compare_at_price
                : null,
            subPrice,
        }
    }

    const discountedRaw = variant.price - (variant.price * (sale.percentageDiscount / 100))
    const discountedRounded = Math.round(discountedRaw / 100) * 100

    let effectiveCompareAt = null
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        effectiveCompareAt = variant.compare_at_price
    } else if (variant.price > discountedRounded) {
        effectiveCompareAt = variant.price
    }

    return { price: discountedRounded, compareAt: effectiveCompareAt, subPrice }
}

// Buy With Prime visibility: only managed on products with the Original/XL Size
// picker. Show when Size=Original AND one-time is selected, hide otherwise.
// On non-Size BWP products this is a no-op so they keep their pre-XL behavior
// (BWP visible on first load, unaffected by the recharge-type toggle).
const updateBwpVisibility = ($form) => {
    const $bwpWidget = $form.querySelector('[data-bwp-widget]')
    if (!$bwpWidget) return

    const $sizeInput = $form.querySelector('.custom-size-picker-input:checked')
    if (!$sizeInput) return

    const sizeIsOriginal = $sizeInput.value === 'Original'

    const $recharge = $form.querySelector('[name="recharge-widget-type"]:checked')
    const isOneTime = !$recharge || $recharge.value === 'one-time'

    $bwpWidget.style.display = (sizeIsOriginal && isOneTime) ? '' : 'none'
}

// Mirrors the Liquid padding rule on size change: BWP applies only to the
// Original variant, so the XL variant of a BWP product needs the same gap as
// a non-BWP product. The px value lives on data-atc-padding-px because it
// varies by template (the `ba` template uses mt-0 on the trust-badges row).
const updateAtcWrapperPadding = ($form) => {
    const $wrapper = $form.querySelector('.product-form__atc-wrapper')
    if (!$wrapper || !$form.querySelector('[data-bwp-widget]')) return
    const $sizeInput = $form.querySelector('.custom-size-picker-input:checked')
    if (!$sizeInput) return
    const px = $wrapper.dataset.atcPaddingPx || '10'
    $wrapper.style.paddingBottom = $sizeInput.value === 'Original' ? '' : `${px}px`
}

// Product options
document.querySelectorAll('.product-option').forEach(($option) => {
    $option.addEventListener('change', () => {
        const $form = $option.closest('form[action="/cart/add"]')

        const selectedOptions = []

        $form.querySelectorAll('.product-option').forEach(($option2) => {
            if ($option2.type === 'radio') {
                if ($option2.checked) {
                    selectedOptions.push($option2.value)
                }
            } else {
                selectedOptions.push($option2.value)
            }
        })

        const selectedVariant = JSON.parse($form.dataset.variants).find(
            (variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
        )

        // console.log(selectedVariant);

        const $addToCartBtn = $form.querySelector('.btn-atc')

        if (selectedVariant) {
            // console.log(selectedVariant);

            $form.querySelector('select[name="id"]').value = selectedVariant.id
            // Keep the sticky-ATC form's variant in sync so its Add to Cart submits the right variant
            // (its own <select> is hidden when the custom Size picker is active).
            const $stickyAtcSelect = document.querySelector('#product-sticky-atc select[name="id"]')
            if ($stickyAtcSelect) {
                $stickyAtcSelect.value = selectedVariant.id
            }

            if (selectedVariant.available) {
                $addToCartBtn.disabled = false
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textAddToCart
            } else {
                $addToCartBtn.disabled = true
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textSoldOut
            }

            // Swap ATC ↔ notify-me on variant-level OOS. Toggles both the main
            // PDP form wrappers and the sticky-ATC mirrors.
            const variantAvailable = selectedVariant.available
            const $productPage = $form.closest('#product-page')
            const $atcWrappers = [
                $form.querySelector('.product-form__atc-wrapper'),
                document.querySelector('#product-sticky-atc .product-sticky-atc__atc-wrapper'),
            ]
            const $notifyWrappers = [
                $productPage && $productPage.querySelector('.product-form__notify-wrapper'),
                document.querySelector('#product-sticky-atc .product-sticky-atc__notify-btn'),
            ]
            $atcWrappers.forEach(($el) => {
                if ($el) $el.classList.toggle('d-none', !variantAvailable)
            })
            $notifyWrappers.forEach(($el) => {
                if ($el) $el.classList.toggle('d-none', variantAvailable)
            })

            const productPriceContainer = $form.closest('#product-page').querySelector('.product-price-container')

            const formatMoneyNoTrailingZeros = (cents) => window.formatMoney(cents)
                .replace(/[.,]00(?=\D|$)/, '')

            const display = computeDisplayPrice(selectedVariant)
            const $priceFinal = productPriceContainer.querySelector('.product-price-final')

            // Refresh the data attributes the recharge-widget toggle reads when
            // the user later switches between One-time and Subscribe — otherwise
            // they'd hold stale values from the initially-rendered variant.
            $priceFinal.dataset.productPrice = Math.round(display.price)
            if (display.subPrice !== null) {
                $priceFinal.dataset.subPrice = Math.round(display.subPrice)
            }

            // If Subscribe is currently active, show the new variant's sub price;
            // otherwise show the (sale-aware) one-time price. Matches the
            // formatters used by the recharge-widget handler below.
            const $rechargeType = $form.querySelector('[name="recharge-widget-type"]:checked')
            const isSubscription = $rechargeType && $rechargeType.value === 'subscription'

            if (isSubscription && display.subPrice !== null) {
                $priceFinal.textContent = window.formatMoney(display.subPrice)
            } else {
                $priceFinal.textContent = formatMoneyNoTrailingZeros(display.price)
            }

            if (display.compareAt) {
                productPriceContainer.querySelector('.product-price-compare')
                    .textContent = formatMoneyNoTrailingZeros(display.compareAt)
                productPriceContainer.querySelector('.product-price-compare')
                    .classList.remove('d-none')
            } else {
                productPriceContainer.querySelector('.product-price-compare')
                    .classList.add('d-none')
            }

            window.history.replaceState({}, '', `${$form.dataset.productUrl}?variant=${selectedVariant.id}`)

            const handledBySizeCarousel = updateSizeCarousel($form)
            if (!handledBySizeCarousel && selectedVariant.featured_media) {
                bootstrap.Carousel.getInstance($form.closest('.product').querySelector('.product-carousel'))
                    .to(selectedVariant.featured_media.position - 1)
            }
        } else {
            $addToCartBtn.disabled = true
            $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textUnavailable
            window.history.replaceState({}, '', window.product.url)
        }

        updateBwpVisibility($form)
        updateAtcWrapperPadding($form)
    })
})

// Product Media Gallery - Full Screen Gallery with PhotoSwipe
// https://photoswipe.com/v5/docs/getting-started/
const initProductMediaGallerySwipe = () => {
    document.querySelectorAll('#product-page .product-carousel').forEach(($carousel) => {
        const lightbox = new PhotoSwipeLightbox({
            gallery: $carousel,
            children: 'a',
            pswpModule: './photoswipe.esm.min.js'
        })
        lightbox.init()
    })
}
initProductMediaGallerySwipe()

// Product Media Gallery - Sticky position on scroll (only in desktop)
const initProductMediaGallerySitcky = () => {
    document.querySelectorAll('.sticky-carousel').forEach(($carousel) => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 20) {
                const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight || 0
                $carousel.style.position = 'sticky'
                $carousel.style.top = `${navbarHeight + 20}px`
            }
        })
    })
}
initProductMediaGallerySitcky()

// Handle Ingredients
const handleIngredients = async () => {
    const ingredientsBlock = document.querySelector('.product-block-ingredients')

    if (ingredientsBlock) {
        const response = await fetch(ingredientsBlock.dataset.jsonFile)
        const data = await response.json()
        console.log(data)

        document.querySelectorAll('.ingredients-list-item').forEach((item) => {
            const ingredientData = data[item.dataset.ingredient]

            if (ingredientData) {
                item.querySelector('.ingrdients-list-score').innerHTML = ingredientData.score
                item.querySelector('.ingrdients-list-score').style.backgroundColor = ingredientData.score > 2 ? 'orange' : 'green'

                item.querySelector('[data-ingredient-origin]').innerHTML = ingredientData.origin
                item.querySelector('[data-ingredient-description]').innerHTML = ingredientData.description
            }
        })

        document.querySelectorAll('.btn-ingredients-show-all').forEach((btn) => {
            btn.addEventListener('click', () => {
                btn.closest('.accordion-body').querySelectorAll('.ingredients-list-item').forEach(item => {
                    item.style.display = 'flex'
                })
                btn.remove()
            })
        })
    }
}
handleIngredients()

// YotPo reviews on product page - small fixes
const $yotooMainWidget = document.querySelector('.yotpo.yotpo-main-widget')
if ($yotooMainWidget) {
    $yotooMainWidget.classList.add('container')
}

// Marquee on product page - move it on mobile below the image gallery
const fixMarqueePositionMobile = () => {
    let $marquee = document.querySelector('body.request-page-type-product .shopify-section > .marquee')

    if ($marquee) {
        $marquee = document.querySelector('.marquee-section-wrapper .marquee')

        const handleTask = () => {
            if (window.matchMedia('(max-width: 991px)').matches) {
                const $target = document.querySelector('#product-page .product-carousels-wrapper')
                    || document.querySelector('#product-page .product-carousel')
                $target.append($marquee)
            } else {
                document.querySelector('.marquee-section-wrapper').append($marquee)
            }
        }
        handleTask()

        window.addEventListener('resize', () => {
            handleTask()
        })
    }
}
fixMarqueePositionMobile()

// Recharge widget
document.querySelectorAll('[name="recharge-widget-type"]').forEach(input => {
    input.addEventListener('change', () => {
        const finalPriceEl = input.closest('#product-page-content').querySelector('[data-product-price]')

        if (input.value === 'one-time') {
            document.querySelector('#recharge-widget-schedule-list-wrapper').style.display = 'none'
            // eslint-disable-next-line no-template-curly-in-string
            finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.productPrice, '${{ amount_no_decimals }}')
        } else {
            document.querySelector('#recharge-widget-schedule-list-wrapper').style.display = 'block'
            finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.subPrice)
        }

        // Sale-event % badge only applies to one-time pricing — sale codes don't
        // stack with the Recharge subscription discount, so the badge would
        // misrepresent the displayed subscription price.
        const isSubscription = input.value !== 'one-time'
        document.querySelectorAll('.discount-label').forEach(el => {
            el.classList.toggle('d-none', isSubscription)
        })

        const $form = input.closest('form[action="/cart/add"]')
        if ($form) updateBwpVisibility($form)
    })
})
